import { render } from "./FormDocument.vue?vue&type=template&id=74a117b9&scoped=true"
import script from "./FormDocument.vue?vue&type=script&lang=js"
export * from "./FormDocument.vue?vue&type=script&lang=js"

import "./FormDocument.vue?vue&type=style&index=0&id=74a117b9&scoped=true&lang=css"

import exportComponent from "D:\\source\\Mobaxe.Docs.App\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74a117b9"],['__file',"src/views/FormDocument.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "74a117b9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('74a117b9', __exports__)) {
    console.log('reload')
    api.reload('74a117b9', __exports__)
  }
  
  module.hot.accept("./FormDocument.vue?vue&type=template&id=74a117b9&scoped=true", () => {
    console.log('re-render')
    api.rerender('74a117b9', render)
  })

}


export default __exports__